
export class _deserializable {

  public deserialize(input: any) {
      Object.assign(this, input);
      return this;
  }
  
}
